import { render, staticRenderFns } from "./deposit-kr.vue?vue&type=template&id=ec5ba8a8&scoped=true&"
import script from "./deposit-kr.vue?vue&type=script&lang=js&"
export * from "./deposit-kr.vue?vue&type=script&lang=js&"
import style0 from "./deposit-kr.vue?vue&type=style&index=0&id=ec5ba8a8&prod&scoped=true&lang=css&"
import style1 from "./deposit-kr.vue?vue&type=style&index=1&id=ec5ba8a8&prod&lang=scss&scoped=true&"
import style2 from "./deposit-kr.vue?vue&type=style&index=2&id=ec5ba8a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5ba8a8",
  null
  
)

export default component.exports